import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/supply/tailored-supply')({
  component: TailoredSupplyLayout,
});

function TailoredSupplyLayout() {
  return <Outlet />;
}
